import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.NumericColumn("Año", "año"),
    ColumnsFactory.DecimalColumn("Tasa IS", "tasa_IS_Matriz", {ipkTotalizar: false}),
    ColumnsFactory.DecimalColumn("Tasa Gtos. Grales.", "tasa_GtosGrales", {ipkTotalizar: false})
  ];
};
